import * as React from 'react';
import { makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import { DateRangePicker } from '@shared/ui-react/DateRangePicker';
import { PageStateStore } from '@shared/user-state/PageStateStore';


@observer
export class SavedViewsPanelFilterComponent extends React.Component<{
    store: PageStateStore;
    mobile?: boolean;
    visiblePresetsCount?: number;
    canShowMarkersOnMap?: boolean;
}> {
    @observable activeDatePreset = 0;

    static defaultProps = {
        visiblePresetsCount: 5,
        mobile: false
    };

    constructor(props: any) {
        super(props);
        makeObservable(this);
    }

    render() {
        const store = this.props.store;

        return (
            <div className='app__common-filters__wrapper' style={{ overflow: this.props.mobile ? 'auto' : 'hidden'}}>
                <main>
                    <div>
                        { this.props.canShowMarkersOnMap && <label style={{ marginBottom: '1em' }} className='checkbox-label'>
                            <input type='checkbox'
                                   checked={store.filter.showMarkersOnMap}
                                   onChange={this.toggleShowOnMap}/>
                            <span>{__(`js_saved_views.show_markers_on_map`)}</span>
                        </label> }

                        <label style={{ marginBottom: '1em' }} className='checkbox-label'>
                            <input type='checkbox'
                                   checked={store.filter.filterOnly2d3d}
                                   onChange={this.toggleOnly2d3d}/>
                            <span>{__('js_saved_views.hide_[2d_or_3d]_views', store.is2dMap ? '3D' : '2D')}</span>
                        </label>
                    </div>

                    <DateRangePicker store={store.filter} onChange={store.setDates} visiblePresetsCount={this.props.visiblePresetsCount} mobile={this.props.mobile} clearable={true}/>
                </main>
            </div>
        );
    }

    toggleShowOnMap = () => {
        this.props.store.filter.showMarkersOnMap = !this.props.store.filter.showMarkersOnMap;
    };

    toggleOnly2d3d = () => {
        this.props.store.filter.filterOnly2d3d = !this.props.store.filter.filterOnly2d3d;
    };
}

